// ============================================================
// BIBLIOTHÈQUE DE MÉDIAS — Curieux Hub
// ------------------------------------------------------------
// Toutes les images et vidéos du site sont référencées ici.
// Les fichiers sont stockés dans /public/media/ (accessible via /media/…).
//
// 🛠️ POUR REMPLACER UNE IMAGE OU UNE VIDÉO :
// 1. Ouvrez le dossier /public/media/images/... ou /public/media/videos/
// 2. Remplacez le fichier en gardant EXACTEMENT le même nom (ex: bain-de-fleurs.png)
// 3. Le site utilisera automatiquement la nouvelle version au prochain chargement.
//
// 🎯 POUR AJOUTER UNE NOUVELLE IMAGE :
// 1. Déposez le fichier dans /public/media/images/... avec un nom clair
// 2. Ajoutez son chemin dans cet objet ci-dessous
// ============================================================

const base = "/media";

export const MEDIA = {
  // ---------- REFUGE ----------
  refuge: {
    heroPoster: `${base}/images/refuge/hero-poster.png`,
    bassin: `${base}/images/refuge/bassin-mineral.png`,
    bassinVueChambre: `${base}/images/refuge/bassin-vue-chambre.jpeg`,
    bassinVueEnsemble: `${base}/images/refuge/bassin-vue-ensemble.jpeg`,
    cuisine: `${base}/images/refuge/cuisine-ete.jpeg`,
    chambre: `${base}/images/refuge/chambre-cocon.png`,
    chambre3voyageurs: `${base}/images/refuge/chambre-3-voyageurs.png`,
    chambreBerceau: `${base}/images/refuge/chambre-berceau.png`,
    jardin: `${base}/images/refuge/jardin-tropical.jpeg`,
    jardinEntree: `${base}/images/refuge/jardin-entree.jpeg`,
    boiteACles: `${base}/images/refuge/boite-a-cles-photo.png`,
    codeAccesIcon: `${base}/images/refuge/code-acces-icon.png`,
    lampadaireCuisine: `${base}/images/refuge/lampadaire-cuisine.png`,
    interrupteurLampadaire: `${base}/images/refuge/interrupteur-lampadaire.png`,
    guirlandeLumineuse: `${base}/images/refuge/guirlande-lumineuse.png`,
    telecommandeGuirlande: `${base}/images/refuge/telecommande-guirlande.webp`,
    retroprojecteur: `${base}/images/refuge/retroprojecteur.png`,
    luminaireChambre: `${base}/images/refuge/luminaire-chambre.png`,
    interrupteurChambre: `${base}/images/refuge/interrupteur-chambre.webp`,
    telecommandeMusique: `${base}/images/refuge/telecommande-musique.webp`,
    retroClimBougie: `${base}/images/refuge/retro-clim-bougie.webp`,
    porteArrivee: `${base}/images/refuge/porte-arrivee.webp`,
  },

  // ---------- EXPÉRIENCES ----------
  experiences: {
    bainDeFleurs: `${base}/images/experiences/bain-de-fleurs.png`,
    petitDejeuner1: `${base}/images/experiences/petit-dejeuner-1.png`,
    petitDejeuner2: `${base}/images/experiences/petit-dejeuner-2.png`,
    decorNuitRouge: `${base}/images/experiences/decor-nuit-rouge.png`,
    decorChandelier: `${base}/images/experiences/decor-chandelier.jpeg`,
    decorTerrasse: `${base}/images/experiences/decor-terrasse.png`,
    nuitRose1: `${base}/images/experiences/nuit-rose-1.jpeg`,
    nuitRose2: `${base}/images/experiences/nuit-rose-2.jpeg`,
    nuitRose3: `${base}/images/experiences/nuit-rose-3.png`,
  },

  // ---------- VIDÉOS ----------
  videos: {
    refugeHeroWebm: `${base}/videos/refuge-hero.webm`,
    refugeHeroMp4: `${base}/videos/refuge-hero.mp4`,
  },
};

export default MEDIA;
